"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeStats = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThreeStatsProvider_1 = require("./ThreeStatsProvider");
var ThreeStats = function () {
    var containerRef = (0, react_1.useRef)(null);
    var stats = (0, ThreeStatsProvider_1.useThreeStats)().stats;
    (0, react_1.useEffect)(function () {
        var e_1, _a;
        var div = containerRef.current;
        if (!div) {
            return;
        }
        try {
            for (var stats_1 = __values(stats), stats_1_1 = stats_1.next(); !stats_1_1.done; stats_1_1 = stats_1.next()) {
                var stat = stats_1_1.value;
                div.appendChild(stat.dom);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (stats_1_1 && !stats_1_1.done && (_a = stats_1.return)) _a.call(stats_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return function () {
            var e_2, _a;
            try {
                for (var stats_2 = __values(stats), stats_2_1 = stats_2.next(); !stats_2_1.done; stats_2_1 = stats_2.next()) {
                    var stat = stats_2_1.value;
                    div.removeChild(stat.dom);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (stats_2_1 && !stats_2_1.done && (_a = stats_2.return)) _a.call(stats_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
    }, [stats]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: containerRef, style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } }));
};
exports.ThreeStats = ThreeStats;
